import React, { useEffect, useState } from 'react';
import styles from './DpTableFlexSection.module.scss';
import RichText from '../../richtext';
import { countZero, getElementMaximumHeight } from '../../../utils/utils';
import SkeletonLoader from '../../SkeletonLoader/SkeletonLoader';
import ToolTip from '../../ToolTip/ToolTip';

const DpTableFlexSection = ({
  productData, //product sb content
  mainContent, //whole content
  selectedDeviceDetails, //selected device details like color, memory and price
  tabIndex,
  indexKey,
  cardsLength,
  activeTab
}: any) => {
  const [flexUpgradePrice, setFlexUpgradePrice] = useState(0);

  useEffect(() => {
    //setting insurance price
    if (
      selectedDeviceDetails?.selectedVarientDetails?.hardwarePrices?.smartUpgradeInstallments
        ?.insurance?.value
    )
      setFlexUpgradePrice(
        selectedDeviceDetails?.selectedVarientDetails?.hardwarePrices?.smartUpgradeInstallments
          ?.insurance?.value
      );

    setTimeout(() => {
      findHeight();
    }, 100);
    window?.addEventListener('load', findHeight);
    window?.addEventListener('resize', findHeight);

    return () => {
      window.removeEventListener('resize', findHeight);
      window.removeEventListener('load', findHeight);
    };
  }, [selectedDeviceDetails]);

  const findHeight = () => {
    getElementMaximumHeight(`flexTitleSection${tabIndex}`, cardsLength);
    getElementMaximumHeight(`flexDescSection${tabIndex}`, cardsLength);
    getElementMaximumHeight(`flexPriceSection${tabIndex}`, cardsLength);
  };

  return (
    <>
      <div className={styles.flexUpgradeSection}>
        {flexUpgradePrice > 0 ? (
          <>
            <div className={styles.flexTitleSection} id={`flexTitleSection${tabIndex}${indexKey}`}>
              <div className={styles.flexTitle}>
                <img src={mainContent?.insuranceIcon?.filename} alt='' width={24} height={24} />
                {productData?.flexTitle}
              </div>
              {mainContent?.tabContainer?.[activeTab]?.brand === 'Apple' && (
                <img src={mainContent?.securityIcon?.filename} alt='' width={40} height={40} />
              )}
            </div>
            <div className={styles.flexDescription} id={`flexDescSection${tabIndex}${indexKey}`}>
              <ul>
                {/* insurance details */}
                {productData?.flexDetails?.length > 0 &&
                  (productData?.flexDetails || [])?.map((details: any) => {
                    return (
                      <li>
                        <img
                          src={details?.icon?.filename ?? details?.mobIcon?.filename}
                          alt=''
                          width={24}
                          height={24}
                        />
                        <RichText content={details?.text} />
                      </li>
                    );
                  })}
              </ul>
            </div>
            <hr />
            <div className={styles.flexPriceSection} id={`flexPriceSection${tabIndex}${indexKey}`}>
              {/* insurance price */}
              {countZero(flexUpgradePrice)}
              <span className={styles.month}>{mainContent?.contractLabel}</span>
              {productData?.flexPriceTooltip && <ToolTip content={productData?.flexPriceTooltip} />}
            </div>
          </>
        ) : (
          <>
            <SkeletonLoader count={5} />
          </>
        )}
      </div>
    </>
  );
};

export default DpTableFlexSection;
